function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GameHelpTemplate = require('./game-help.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');

/**
 * GameHelp is a small triangle that will show up on the bottom-left of the
 * screen and toggle an overlay that can be filled with customized advice
 * when the user clicks on it.
 */
var GameHelp = /*#__PURE__*/function () {
  /**
   * @param app - the Saito application
   * @param mod - reference to the game module
   */
  function GameHelp(app, mod) {
    _classCallCheck(this, GameHelp);
    this.app = app;
    this.game_mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.game_mod);
    this.enabled = true;
    if (app.options) {
      if (app.options.gameprefs) {
        if (app.options.gameprefs.his_expert_mode) {
          if (app.options.gameprefs.his_expert_mode == 1) {
            this.enabled = false;
          }
        }
      }
    }
  }
  return _createClass(GameHelp, [{
    key: "hide",
    value: function hide() {
      if (this.enabled != true) {
        return;
      }
      var gh = document.querySelector('.game-help');
      if (gh) {
        gh.classList.remove('game-help-visible');
        gh.classList.add('game-help-hidden');
      }
    }
  }, {
    key: "renderCustomOverlay",
    value: function renderCustomOverlay() {
      var c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var targs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (this.enabled != true) {
        return;
      }
      var gh = document.querySelector('.game-help');
      if (gh) {
        gh.classList.remove('game-help-hidden');
        gh.classList.add('game-help-visible');
      } else {
        this.app.browser.addElementToDom(GameHelpTemplate(targs));
        gh = document.querySelector('.game-help');
      }
      if (targs.fontsize) {
        document.querySelector('.game-help-text').style.fontSize = targs.fontsize;
      }
      if (targs.line1) {
        document.querySelector('.game-help-text .line1').innerHTML = targs.line1;
      }
      if (targs.line2) {
        document.querySelector('.game-help-text .line2').innerHTML = targs.line2;
      }
      this.attachEventsCustomOverlay(c);
    }
  }, {
    key: "render",
    value: function render() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var targs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (this.enabled != true) {
        return;
      }
      var gh = document.querySelector('.game-help');
      if (gh) {
        gh.classList.remove('game-help-hidden');
        gh.classList.add('game-help-visible');
      } else {
        this.app.browser.addElementToDom(GameHelpTemplate(targs));
        gh = document.querySelector('.game-help');
      }
      if (targs.fontsize) {
        document.querySelector('.game-help-text').style.fontSize = targs.fontsize;
      }
      if (targs.line1) {
        document.querySelector('.game-help-text .line1').innerHTML = targs.line1;
      }
      if (targs.line2) {
        document.querySelector('.game-help-text .line2').innerHTML = targs.line2;
      }
      this.attachEvents(t, targs);
    }
  }, {
    key: "attachEventsCustomOverlay",
    value: function attachEventsCustomOverlay() {
      var _this = this;
      var c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var gh = document.querySelector('.game-help');
      gh.onclick = function (e) {
        _this.game_mod.displayCustomOverlay(c);
        _this.toggle();
      };
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var targs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var gh = document.querySelector('.game-help');
      gh.onclick = function (e) {
        if (t != null) {
          _this2.overlay.show(t(targs));
          if (targs.img) {
            document.querySelector('.tutorial-overlay').style.backgroundImage = "url(\"".concat(targs.img, "\")");
          }
        }
        _this2.toggle();
      };
    }
  }, {
    key: "toggle",
    value: function toggle() {
      var gh = document.querySelector('.game-help');
      if (!gh.classList.contains('game-help-hidden')) {
        this.hide();
      } else {
        this.render();
      }
    }
  }]);
}();
module.exports = GameHelp;